import { render, staticRenderFns } from "./loaderCircle.vue?vue&type=template&id=4b4e2bf6&scoped=true&"
import script from "./loaderCircle.vue?vue&type=script&lang=js&"
export * from "./loaderCircle.vue?vue&type=script&lang=js&"
import style0 from "./loaderCircle.vue?vue&type=style&index=0&id=4b4e2bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e2bf6",
  null
  
)

export default component.exports